module.exports = __webpack_public_path__ + "static/media/phytoplankton.01ac9387.png";